/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_RegistermethodeInputs */

const de__field_registermethode = /** @type {(inputs: _Field_RegistermethodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldemethode`)
};

/**

* @param {_Field_RegistermethodeInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_registermethode = /** @type {((inputs?: _Field_RegistermethodeInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_RegistermethodeInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_registermethode(inputs)
});